export default "__VITE_ASSET__BoeIFlQT__"